import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface LoginPayload {
  username: string;
  password: string;
  user_token: string | null;
}

export interface Account {
  account_id: string;
  /** Used with `AccountThemeService` to pick a shared theme for the group. */
  account_group_id?: number;
  account_name: string;
  block_name?: string;
  floor_unit?: string;
  floor_unit_id?: number | string;
  is_approved?: number;
  [key: string]: unknown;
}

export interface UserData {
  user_id: string;
  role_id?: string;
  username?: string;
  role_name?: string;
  email_id?: string;
  first_name?: string;
  last_name?: string;
  profile_pic?: string;
  accounts?: Account[];
  /** JWT or API token returned by login — required for protected routes */
  access_token?: string;
  token?: string;
  auth_token?: string;
  refresh_token?: string;
  [key: string]: unknown;
}

export interface LoginResponse {
  success: boolean;
  message?: string;
  data?: UserData;
  [key: string]: unknown;
}

export interface LoginBrandingPayload {
  domain_url: string;
}

export interface LoginBrandingConfig {
  brandName?: string;
  welcomeTitle?: string;
  logoPath?: string;
  pageClass?: string;
  gradientStart?: string;
  gradientEnd?: string;
  logoBgStart?: string;
  logoBgMid?: string;
  logoBgEnd?: string;
  titleColor?: string;
  subtitleColor?: string;
}

export interface LoginBrandingResponse {
  success?: boolean;
  message?: string;
  data?: LoginBrandingConfig;
  [key: string]: unknown;
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly baseUrl = environment.baseUrl;

  constructor(private readonly http: HttpClient) {}

  login(payload: LoginPayload): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(`${this.baseUrl}/login`, payload);
  }

  getLoginBranding(payload: LoginBrandingPayload): Observable<LoginBrandingResponse> {
    return this.http.post<LoginBrandingResponse>(`${this.baseUrl}/login-branding`, payload);
  }
}








